import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1431bea5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431bea5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/toutiaoApp/index.vue
// module id = null
// module chunks = 